import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_result = _resolveComponent("a-result")!

  return (_openBlock(), _createBlock(_component_a_result, {
    status: "warning",
    title: "There are some problems with your operation."
  }, {
    extra: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "console",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Go Console")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}